import { createSelector } from 'reselect';
import { PREDEFINED_TREE_NODES } from '../data/consts';
import { selectGoogleDrive } from '.';

const selectTree = createSelector(selectGoogleDrive, (gdrive) => gdrive.tree);

export const selectTreeFolders = createSelector(selectTree, (tree) => tree.folders);

export const selectMyDrive = createSelector(selectTreeFolders, (folders) => folders[PREDEFINED_TREE_NODES.MY_DRIVE]);

const selectSharedDrive = createSelector(selectTreeFolders, (folders) => folders[PREDEFINED_TREE_NODES.SHARED_DRIVE]);

const selectSharedWithMe = createSelector(selectTreeFolders, (folders) => folders[PREDEFINED_TREE_NODES.SHARED_WITH_ME]);

const selectStarred = createSelector(selectTreeFolders, (folders) => folders[PREDEFINED_TREE_NODES.STARRED]);

const selectRecent = createSelector(selectTreeFolders, (folders) => folders[PREDEFINED_TREE_NODES.RECENT]);

export const selectTreeStatuses = createSelector(selectTree, (tree) => tree.statuses);

export const selectTreeDefaultExpanded = createSelector(selectMyDrive, ({ id, kind, driveId, path }) => ({
  id,
  kind,
  driveId,
  path,
}));

const flatten = (node, depth, acc, dictionary) => {
  if (node) {
    acc.push({
      ...node,
      depth,
    });

    if (node.children && node.children.length > 0) {
      node.children.forEach((childNodeId) => {
        if (dictionary[childNodeId]) {
          flatten(dictionary[childNodeId], depth + 1, acc, dictionary);
        }
      });
    }
  }

  return acc;
};

export const selectTreeItems = createSelector(
  selectMyDrive,
  selectSharedDrive,
  selectSharedWithMe,
  selectStarred,
  selectRecent,
  selectTreeFolders,
  (myDriveFolder, sharedDriveFolder, sharedWithMe, starred, recent, ...args) => [
    ...flatten(myDriveFolder, 0, [], ...args),
    ...flatten(sharedDriveFolder, 0, [], ...args),
    ...flatten(sharedWithMe, 0, [], ...args),
    ...flatten(starred, 0, [], ...args),
    ...flatten(recent, 0, [], ...args),
  ]
);
